import ROUTES from '../routes';
import ImportPage from '../hoc/import/import-page';
import ImportItem from '../hoc/import/import-item';

const ImportRoutes = {
  path: ROUTES.IMPORT,
  element: <ImportPage />,
  children: [
    {
      path: ROUTES.IMPORT_ITEM,
      element: <ImportItem />,
    },
  ],
};

export default ImportRoutes;
